import { reactive,computed } from 'vue'
import Browser from '../../lib/browser'

// state
const state = reactive({
  responsive:'pc',
  windowWidth:0,
  windowHeight:0,
  isTouch:false,
  keydownKey:'',
  shiftKey:false,
  windowWidthHalf:computed(()=>{return state.windowWidth>>1}),
  windowHeightHalf:computed(()=>{return state.windowHeight>>1}),
})

/**
 * 初期化
 */
function init(){
  Browser.init()
  
  state.isTouch = Browser.isTouch
  
  state.windowWidth = Browser.windowWidth
  state.windowHeight = Browser.windowHeight
  Browser.addResizeHandler(()=>{
    state.windowWidth = Browser.windowWidth
    state.windowHeight = Browser.windowHeight
  })

  state.responsive = Browser.responsive
  Browser.addResponsiveHandler(()=>{
    state.responsive = Browser.responsive
  })

  window.addEventListener('keydown',(e)=>{
    state.keydownKey = e.key
    state.shiftKey = e.shiftKey
  })
  window.addEventListener('keyup',(e)=>{
    state.keydownKey = ''
    state.shiftKey = false
  })
}


//=============================
//
// ローカル関数
//
//=============================

export default {
  namespaced: true,
  state,
  init
}
